const VerifyEmailConfig = {
  endpoints: {
    verify: "/register/verify",
  },
};

export default VerifyEmailConfig;
